// extracted by mini-css-extract-plugin
export default {"container":"PageLoader_container__+dMRM","loaderFull":"PageLoader_loaderFull__USe1Z"};